import styled from 'styled-components/native';
import {RFValue} from 'react-native-responsive-fontsize';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';

export const Container = styled.View`
  border-style: solid;
  border-bottom-width: 1px;
  border-bottom-color: ${({theme}) => theme.colors.border};
  padding-bottom: ${RFValue(12)}px;
  margin-bottom: ${RFValue(12)}px;
`;

export const SectionHeader = styled.View`
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const Title = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(14)}px;
  margin-bottom: ${RFValue(4)}px;
`;

export const HelpButtonCircle = styled.TouchableOpacity`
  padding: ${RFValue(4)}px;
`;

export const HelpButtonIcon = styled(MaterialCommunityIcons)`
  color: ${({theme}) => theme.colors.blue};
  font-size: ${RFValue(14)}px;
`;
